import { render } from "./ResponseTimeChart.vue?vue&type=template&id=94c651ba&ts=true"
import script from "./ResponseTimeChart.vue?vue&type=script&lang=ts"
export * from "./ResponseTimeChart.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__